export const mutations = {

    adminRequestsSetCurrent(state, data) {
        state.adminRequestCurrent = data
    },

    resetState(state) {
        state.adminRequestCurrent = {};
    }

};
